import { useVersion } from '@/lib/queries'
import { formatFull } from '@/lib/time'
import { cn } from '@/lib/utils'

/** The commit the server was built from, so a screenshot says which build. */
export function BuildStamp({ compact, className }: { compact?: boolean; className?: string }) {
  const v = useVersion()
  const commit = v.data?.commit ? v.data.commit.slice(0, 7) : '…'
  const built = v.data?.built_at ? formatFull(v.data.built_at) : ''
  return (
    <span
      title={built ? `빌드 ${v.data?.commit} · ${built}` : undefined}
      className={cn('text-micro text-sidebar-muted', className)}
    >
      {!compact && '빌드 '}
      <span className="font-mono">{compact ? commit.slice(0, 4) : commit}</span>
    </span>
  )
}
